import Quill, { Range } from 'quill';

type ClipboardConstructor = new (...args: any[]) => {
    onPaste(range: Range, data: { text?: string; html?: string }): void;
};

const Clipboard = Quill.import('modules/clipboard') as ClipboardConstructor;

export class CustomClipboard extends Clipboard {
    override onPaste(range: Range, { text }: { text?: string; html?: string }) {
        const normalizedText = (text ?? '').replace(/\r?\n/g, ' ');

        super.onPaste(range, { text: normalizedText });
    }
}

Quill.register('modules/clipboard', CustomClipboard, true);
